import { Link as InboundLink } from "gatsby"
import PropTypes from "prop-types"
import { trackEvent } from "lib/googleTagManager"

/**
 * Link component that can handle both internal and external links
 * - Internal links pass through Gatsby's Link component, which is responsible
 *   for routing throughout the application.
 * - External links pass through the GA plugin's OutboundLink component, which
 *   tracks external links in GA
 */
function Link({ href, children, openNewTab, ...rest }) {
  if (
    href &&
    (/https?:\/\//.test(href) ||
      href.startsWith("mailto:") ||
      href.startsWith("tel:"))
  ) {
    return (
      <a
        href={href}
        {...rest}
        onClick={() =>
          trackEvent("outboundLinkClick", { outboundLinkHref: href })
        }
        data-outboundlink="true"
        target={openNewTab && "_blank"}
        rel={openNewTab && "noopener noreferrer"}
      >
        {children}
      </a>
    )
  }

  return (
    <InboundLink to={href} {...rest}>
      {children}
    </InboundLink>
  )
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default Link
